import React from 'react'
import { IShape } from '..'
import { shapeSizes } from './Shape'

export const LeftHalfSemicircle = ({ className, size, color }: IShape): React.ReactElement => {
  return (
    <svg
      className={className}
      width="1440"
      height={shapeSizes[size]}
      viewBox="0 0 1440 84"
      fill="none"
      preserveAspectRatio="none"
    >
      <path d="M1440 85H0v-2C458.698 26.24 931.453 0 1406.246 0H1440Z" fill={color} />
    </svg>
  )
}
